<template>
  <div>
    <wc-data-box
      title='Totals'
      :loading='loading'
    >
      <wc-two-column-table :items='divisionTotals'></wc-two-column-table>
    </wc-data-box>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'budget-totals',
  props: {
    budget: {
      required: true
    },
    lines: {
      required: true
    },
    loading: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({

  }),
  computed: {
    budgetTotal () {
      return _.sumBy(this.lines, 'amount')
    },
    divisionTotals () {
      let data = []
      let noDiv = _.filter(this.lines, l => l.division === null)
      data.push({ text: 'No division', value: this.$options.filters.dec(_.sumBy(noDiv, 'amount'))})
      let divs = _.sortBy(this.$store.state.misc.divisions, 'order')
      for (let d = 0; d < divs.length; d++) {
        let divLines = _.filter(this.lines, l => l.division === divs[d].id)
        data.push({ text: divs[d].division, value: this.$options.filters.dec(_.sumBy(divLines, 'amount'))})
      }
      data.push({ text: 'Budget Total', value: this.$options.filters.decMoney(this.budgetTotal), bold: true })
      return data
    }
  },
  methods: {

  }
}
</script>
